/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbExternalEhrDocument
 */
export interface HchbExternalEhrDocument {
    /**
     * 
     * @type {string}
     * @memberof HchbExternalEhrDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbExternalEhrDocument
     */
    external_document_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof HchbExternalEhrDocument
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof HchbExternalEhrDocument
     */
    error_message?: string;
}

/**
 * Check if a given object implements the HchbExternalEhrDocument interface.
 */
export function instanceOfHchbExternalEhrDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbExternalEhrDocumentFromJSON(json: any): HchbExternalEhrDocument {
    return HchbExternalEhrDocumentFromJSONTyped(json, false);
}

export function HchbExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbExternalEhrDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'external_document_id': !exists(json, 'external_document_id') ? undefined : json['external_document_id'],
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
    };
}

export function HchbExternalEhrDocumentToJSON(value?: HchbExternalEhrDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'external_document_id': value.external_document_id,
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'error_message': value.error_message,
    };
}

